import React from 'react';
import PropTypes from 'prop-types';

import colors from 'pubweb-react-components/dist/styles/colors';

import Button from 'pubweb-react-components/dist/components/Buttons/Button';
import WindowSizeComponent from 'pubweb-react-components/dist/components/WindowSize/WindowSizeComponent';
import InputField from 'pubweb-react-components/dist/components/Forms/InputField';
import CheckBox from 'pubweb-react-components/dist/components/Forms/Checkbox/Checkbox';
import Spinner from 'pubweb-react-components/dist/components/Icons/Spinner';

import variables from '../variables';

import Form from 'pubweb-react-components/dist/components/Forms/Form';
import { runCommonValidation } from 'pubweb-react-components/dist/utils/validation';
import { submitForm } from '../../services/formService';
import TemplateFormStyles from './TemplateForm.styled';
import { trackGAEvent } from '../../utils/analytics';
import { logError } from '../../services/logService';


const customMessages = {
    firstNameMissing: "First name is required.",
    lastNameMissing: "Last name is required.",
    emailMissing: "Email address is required.",
    zipMissing: "Zip code is required.",
    phoneMissing: "Phone number is required."
};

class PrefabForm extends WindowSizeComponent {
    constructor(props){
        super(props);

        this.state = {
            formData: {},
            formErrors: {},
            formSubmitError: false,
            showExtended: false,
            submittingForm: false,
            windowWidth: window ? (window.innerWidth || window.screen.availWidth ) : variables.desktop_breakpoint_width
        };

        this.handleValidation = this.handleValidation.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFormChange = this.handleFormChange.bind(this);
    }

    handleFormChange(formData){
        this.setState({
            formData: {...this.state.formData,
                       ...formData}
        });
    }

    handleValidation(formState){
        const formErrors = runCommonValidation(formState, customMessages);

        this.setState({
            formErrors: formErrors
        });

        return formErrors.hasErrors;
    }

    handleSubmit(formData){
        this.setState({
            submittingForm: true,
            formSubmitError: false
        });

        const formSubmission = {
            ...formData,
            canEmail: true,
            originWebApp: 'clayton-homes-website',
            originWebPageType: 'quiz-landing-page',
            originCampaign: 'clayton-paid',
            originWebFormType: 'lead-form',
            dataExtension: 'FormActivityClaytonPaid',
            originWebFormCategory: this.props.category
        };
        submitForm(formSubmission).then(() => {
            trackGAEvent('quizFormSubmission')
                .finally(() => {
                    window.location.href = `${this.props.redirectUrl}?zip=${formData.zip}`;
                });
        }).catch(error => {
            logError(error);
            this.setState({
                submittingForm: false,
                formSubmitError: true
            });
        });
    }

    render(){

        const formErrors = this.state.formErrors;

        return <TemplateFormStyles className={this.props.className}>
            {this.state.formSubmitError ? <span className="form-error">An error occurred while submitting the form. Please try again.</span> : null}
            <Form onFormChange={this.handleFormChange} onFormValidate={this.handleValidation} onSubmit={this.handleSubmit}>
                <div className="field-row">
                    <InputField fillSpace={true} inputName="Email*" inputId="email" error={formErrors.email} errorMsg={formErrors.email} />
                </div>
                <div className="field-group">
                    <div className="field-column">
                        <InputField initialValue={this.state.formData.firstName} fillSpace={true} inputName="First Name*" inputId="firstName" error={formErrors.firstName} errorMsg={formErrors.firstName} />
                    </div>
                    <div className="field-column">
                        <InputField initialValue={this.state.formData.lastName} fillSpace={true} inputName="Last Name*" inputId="lastName" error={formErrors.lastName} errorMsg={formErrors.lastName} />
                    </div>
                    <div className="field-column">
                        <InputField initialValue={this.state.formData.zip} fillSpace={true} inputName="Zip Code*" inputId="zip" error={formErrors.zip} errorMsg={formErrors.zip} />
                    </div>   
                    <div className="field-column">
                        <InputField initialValue={this.state.formData.phone} fillSpace={true} inputName="Phone Number*" inputId="phone" error={formErrors.phone} errorMsg={formErrors.phone} />
                    </div>
                </div>
                <Button
                    size="medium"
                    fillSpace={true}
                    disabled={this.state.submittingForm}
                    backgroundColor={colors.secondaryKiddiePool}
                    backgroundColorHover={colors.primaryClaytonBlue}>
                        {this.state.submittingForm ? <Spinner color="#FFFFFF" /> : 'Unlock Content' }
                </Button>
            </Form> 
        </TemplateFormStyles>;
    }
}

PrefabForm.props = {
    category: PropTypes.string.isRequired,
    leadRedirectUrl: PropTypes.string.isRequired,
    marketingRedirectUrl: PropTypes.string.isRequired,
    buttonColor: PropTypes.string.isRequired,
    buttonHoverColor: PropTypes.string.isRequired,
    className: PropTypes.string
};

export default PrefabForm;